var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 2C9.91857 2 5 6.8515 5 12.85C5 20.9875 16 30 16 30C16 30 27 20.9875 27 12.85C27 6.8515 22.0814 2 16 2Z",
    fill: "#05B88D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.801 12.113L9.071 12.806C10.52 12.707 11.609 12.311 12.122 11.627C12.635 12.311 13.742 12.707 15.191 12.806L15.443 12.113C13.814 12.014 12.851 11.582 12.671 10.934H15.074V10.241H12.59V9.53H11.663V10.241H9.188V10.934H11.582C11.402 11.582 10.448 12.014 8.801 12.113ZM12.59 13.796H15.803V13.103H8.468V13.796H11.663V14.426H9.323V15.11H13.976V15.677H9.341V17.621H15.119V16.928H10.259V16.316H14.885V14.426H12.59V13.796ZM23.7263 11.231H22.5833V9.566H21.6563V13.733H22.5833V11.996H23.7263V11.231ZM20.3513 13.463V9.908H19.4333V10.979H17.4443V9.908H16.5173V13.463H20.3513ZM19.4333 11.69V12.725H17.4443V11.69H19.4333ZM18.2633 16.892V16.172H22.5833V14.093H17.3363V14.813H21.6653V15.488H17.3543V17.621H22.8533V16.892H18.2633Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartPoint);
export default __webpack_public_path__ + "static/media/startPoint.0a36f54497d439008b9df1772616f7fa.svg";
export { ForwardRef as ReactComponent };